import _regeneratorRuntime from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { encode as base64url } from '../../runtime/base64url.js';
import _sign from '../../runtime/sign.js';
import isDisjoint from '../../lib/is_disjoint.js';
import { JWSInvalid } from '../../util/errors.js';
import { encoder, decoder, concat } from '../../lib/buffer_utils.js';
import checkKeyType from '../../lib/check_key_type.js';
import validateCrit from '../../lib/validate_crit.js';

var FlattenedSign = /*#__PURE__*/function () {
  function FlattenedSign(payload) {
    _classCallCheck(this, FlattenedSign);

    if (!(payload instanceof Uint8Array)) {
      throw new TypeError('payload must be an instance of Uint8Array');
    }

    this._payload = payload;
  }

  _createClass(FlattenedSign, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }

      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this._unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }

      this._unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "sign",
    value: function () {
      var _sign2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
        var joseHeader, extensions, b64, alg, payload, protectedHeader, data, signature, jws;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._protectedHeader && !this._unprotectedHeader)) {
                  _context.next = 2;
                  break;
                }

                throw new JWSInvalid('either setProtectedHeader or setUnprotectedHeader must be called before #sign()');

              case 2:
                if (isDisjoint(this._protectedHeader, this._unprotectedHeader)) {
                  _context.next = 4;
                  break;
                }

                throw new JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');

              case 4:
                joseHeader = _objectSpread({}, this._protectedHeader, {}, this._unprotectedHeader);
                extensions = validateCrit(JWSInvalid, new Map([['b64', true]]), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
                b64 = true;

                if (!extensions.has('b64')) {
                  _context.next = 11;
                  break;
                }

                b64 = this._protectedHeader.b64;

                if (!(typeof b64 !== 'boolean')) {
                  _context.next = 11;
                  break;
                }

                throw new JWSInvalid('The "b64" (base64url-encode payload) Header Parameter must be a boolean');

              case 11:
                alg = joseHeader.alg;

                if (!(typeof alg !== 'string' || !alg)) {
                  _context.next = 14;
                  break;
                }

                throw new JWSInvalid('JWS "alg" (Algorithm) Header Parameter missing or invalid');

              case 14:
                checkKeyType(alg, key, 'sign');
                payload = this._payload;

                if (b64) {
                  payload = encoder.encode(base64url(payload));
                }

                if (this._protectedHeader) {
                  protectedHeader = encoder.encode(base64url(JSON.stringify(this._protectedHeader)));
                } else {
                  protectedHeader = encoder.encode('');
                }

                data = concat(protectedHeader, encoder.encode('.'), payload);
                _context.next = 21;
                return _sign(alg, key, data);

              case 21:
                signature = _context.sent;
                jws = {
                  signature: base64url(signature),
                  payload: ''
                };

                if (b64) {
                  jws.payload = decoder.decode(payload);
                }

                if (this._unprotectedHeader) {
                  jws.header = this._unprotectedHeader;
                }

                if (this._protectedHeader) {
                  jws.protected = decoder.decode(protectedHeader);
                }

                return _context.abrupt("return", jws);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign2.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return FlattenedSign;
}();

export { FlattenedSign };
export default FlattenedSign;